import { createContext, useContext } from 'react';

// Presentation stays shared with cloud Work. Execution owners supply only
// catalog/settings and file callbacks; they do not replace the controls.
export const WorkExecutionContext = createContext(null);
export const useWorkExecution = () => useContext(WorkExecutionContext);
